export default "__VITE_PUBLIC_ASSET__e24f369e__"